export default "__VITE_ASSET__CyvZGjIb__"